import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Home from './pages/Home';
import MagazinePage from './pages/MagazinePage';
import MagazineDetailsPage from "./pages/MagazineDetailsPage";
import WomenPage from "./pages/WomenPage";
import ProfilePage from './pages/ProfilePage';
import AboutPage from './pages/AboutPage';
import ArticlePage from './pages/ArticlePage';
import Blogs from "./pages/Blogs";
import BlogDetailPage from "./pages/BlogDetailPage";
import PressReleasePage from "./pages/PressReleasePage";
import AdminRoot from './pages/admin/AdminRoot';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import PrivacyPolicy from "./pages/PrivacyPolicy";
import EditorialPolicy from "./pages/EditorialPolicy";

import Social from './components/Social';

// Scrolls the window to the top on every route change.
// Must live inside <BrowserRouter> so useLocation() works.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window.HTMLElement.prototype ? 'instant' : 'auto' });
  }, [pathname]);

  return null;
}

// Wrap public pages with Navbar + Footer + floating Social rail
function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main id="main">{children}</main>
      <Footer />
      <Social />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public site */}
        <Route path="/" element={
          <PublicLayout><Home /></PublicLayout>
        } />
        <Route
          path="/profile/:id"
          element={
            <PublicLayout>
              <ProfilePage />
            </PublicLayout>
          }
        />
        <Route path="/magazine" element={
          <PublicLayout><MagazinePage /></PublicLayout>
        } />
        {/* Women in Business */}
        <Route path="/women-in-business" element={
          <PublicLayout><WomenPage /></PublicLayout>
        } />
        {/* ⭐ Magazine Details  */}
        <Route
          path="/magazine/:id"
          element={
            <PublicLayout>
              <MagazineDetailsPage />
            </PublicLayout>
          }
        />
        <Route
          path="/about"
          element={
            <PublicLayout>
              <AboutPage />
            </PublicLayout>
          }
        />
        {/* Blogs page  */}
        <Route
          path="/blogs"
          element={
            <PublicLayout>
              <Blogs />
            </PublicLayout>
          }
        />
        {/* Blog detail page */}
        <Route
          path="/blog/:id"
          element={
            <PublicLayout>
              <BlogDetailPage />
            </PublicLayout>
          }
        />

        {/* Press Release page */}
        <Route
          path="/category/press-release"
          element={
            <PublicLayout>
              <PressReleasePage />
            </PublicLayout>
          }
        />

        <Route
          path="/article/:id"
          element={
            <PublicLayout>
              <ArticlePage />
            </PublicLayout>
          }
        />
        {/* Admin — full screen, no navbar/footer */}
        <Route path="/admin/*" element={<AdminRoot />} />

        {/* Fallback */}
        <Route path="*" element={
          <PublicLayout><Home /></PublicLayout>
        } />
        {/* Privacy Policy */}
        <Route path="/privacy-policy" element={
          <PublicLayout><PrivacyPolicy /></PublicLayout>
        } />
        {/* Editorial Policy */}
        <Route path="/editorial-policy" element={
          <PublicLayout><EditorialPolicy /></PublicLayout>
        } />
      </Routes>
    </BrowserRouter>
  );
}